export default __webpack_public_path__ + "static/media/line-plot-blue.36180d77.svg";